/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */

export type PaymentTermsBasis =
  (typeof PaymentTermsBasis)[keyof typeof PaymentTermsBasis];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTermsBasis = {
  net: 'net',
  eom: 'eom',
  due_on_receipt: 'due_on_receipt'
} as const;
